<template>
    <LiefengContent>
        <template v-slot:title>成员管理</template>
        <template v-slot:toolsbarRight>
            <Button style="margin: 0 5px 0 13px" type="primary" icon="md-add" @click="addContact">新增</Button>
        </template>
        <template v-slot:contentArea>
            <LiefengTable
                :talbeColumns="talbeColumns"
                :tableData="tableData"
                :total="total"
                :curPage="pageNumber"
                @hadlePageSize="getList"
                :loading="loading"
                :fixTable="true"
                :pageSize="pageSize"
                :pagesizeOpts="[20, 30, 50, 100]"
            ></LiefengTable>
            <!-- 新增赞助商 -->
            <LiefengModal title="新增成员" :value="userModal" @input="addSponsorFn">
                <template v-slot:contentarea>
                    <Form ref="contactUser" :model="contactUser" :rules="userValidate" :label-width="80">
                        <FormItem label="选择成员" prop="contactUser">
                            <elem-select
                                style="width: 300px"
                                placeholder="请输入用户名或手机号码进行搜索"
                                :remotely="{ api: '/gateway/apps/basic/api/base/uc/getByMobileOrNickname', search: 'mobileOrNickname', id: 'globalId', value: 'nickName' }"
                                :multiple="true"
                                :value="contactUser.globalId"
                                @on-change="contactUser.globalId = $event.value.join('')"
                            ></elem-select>
                        </FormItem>
                        <FormItem label="角色" prop="role">
                            <Select v-model="contactUser.role" transfer>
                                <Option value="1">管理员</Option>
                                <Option value="2">导购员</Option>
                                <!-- <Option value="3">删除导购成员</Option> -->
                            </Select>
                        </FormItem>
                        <FormItem label="是否启用" prop="role">
                            <RadioGroup v-model="contactUser.idisplay">
                                <Radio label="1">启用</Radio>
                                <Radio label="0">禁用</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Form>
                </template>
                <template v-slot:toolsbar>
                    <Button type="info" @click="addSponsorFn(false)">取消</Button>
                    <Button style="margin-left: 10px" type="primary" @click="saveContactUser('contactUser')">保存</Button>
                </template>
            </LiefengModal>
        </template>
    </LiefengContent>
</template>

<script>
//@route("/sponsorcontactuser")
import { validateMobile, validateEmail } from "@/utils/validate"
import LiefengContent from "@/components/LiefengContent3"
import LiefengModal from "@/components/LiefengModal"
import LiefengTable from "@/components/LiefengTable"
import ElemSelect from "../../components/elem-select.vue"
export default {
    data() {
        return {
            loading: false,
            total: 0,
            pageNumber: 1,
            pageSize: 20,
            tableData: [],
            talbeColumns: [
                {
                    title: "名称",
                    key: "username",
                    minWidth: 80,
                    align: "center",
                },
                {
                    title: "手机号",
                    key: "mobile",
                    minWidth: 80,
                    align: "center",
                },
                {
                    title: "操作",
                    width: 100,
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "Button",
                            {
                                props: {
                                    type: "error",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        this.remove(params)
                                    },
                                },
                            },
                            "删除"
                        )
                    },
                },
            ],
            userModal: false,
            urlParams: {},
            contactUser: {
                globalId: "",
                role: "",
                idisplay: "1",
            },
            userValidate: {
                globalId: [
                    {
                        required: true,
                        message: "globalId不能为空",
                        trigger: "blur",
                    },
                ],
                role: [
                    {
                        required: true,
                        validator: "角色不能为空",
                        trigger: "blur",
                    },
                ],
            },
        }
    },
    methods: {
        addSponsorFn(status) {
            this.userModal = status
        },
        getList(data) {
            this.loading = true
            let params = {
                terminalGroupId: this.$route.query.terminalGroupId,
                page: this.pageNumber,
                pageSize: this.pageSize,
            }
            if (data) {
                params.page = data.page
                params.pageSize = data.pageSize
            }

            this.$get("/gateway/apps/o2o/api/terminal/selectTerminalAdminPage", params)
                .then(res => {
                    if (res.code === "200") {
                        res.dataList.map(item => {
                            if (item.gmCreate) {
                                item.gmCreate = this.$core.formatDate(new Date(item.gmCreate), "yyyy-MM-dd hh:mm:ss")
                            }
                        })
                        this.tableData = res.dataList
                        this.loading = false
                    } else {
                        this.$Message.error({
                            background: true,
                            content: "获取数据失败",
                        })
                        this.loading = false
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        addContact() {
            this.userModal = true
            this.contactUser = {
                globalId: "",
                role: "",
                idisplay: "1",
            }
        },
        saveContactUser(name) {
            this.$refs[name].validate(valid => {
                if (valid) {
                    let params = {
                        ...this.contactUser,
                        terminalGroupId: this.$route.query.terminalGroupId,
                        idisplay: 1,
                    }
                    this.$post("/gateway/apps/o2o/api/terminal/addTerminalGroupAdmin", params, { "Context-Type": "Application/json" })
                        .then(res => {
                            if (res.code === "200") {
                                this.$Message.success("操作成功")
                                this.userModal = false
                                this.contactUser = {}
                                this.getList()
                            } else {
                                this.$Message.error({
                                    background: true,
                                    content: "操作失败",
                                })
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                }
            })
        },
        cancal() {},
        updateMobile() {},
        remove(data) {
            this.$Modal.confirm({
                title: "是否删除",
                content: "是否删除当前成员？",
                onOk: () => {
                    if (data) {
                        let params = {
                            id: data.row.id,
                        }
                        this.$get("/gateway/apps/o2o/api/terminal/deleteTerminalGroupAdmin", params).then(res => {
                            if (res.code === "200") {
                                this.$Message.success("操作成功")
                                this.getList()
                            } else {
                                this.$Message.error({
                                    background: true,
                                    content: "操作失败",
                                })
                            }
                        })
                    }
                },
            })
        },
        setSelection() {},
    },
    created() {
        this.getList()
    },
    components: {
        LiefengContent,
        LiefengModal,
        LiefengTable,
        ElemSelect,
    },
}
</script>
    
<style scoped lang='less'>
</style>